var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchChecklistDarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TP_DIY-PBA-Characterization---1",
    transform: "translate(-243.000000, -310.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CC-Advanced-Side-Nav",
    transform: "translate(0.000000, 56.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Reports",
    transform: "translate(237.000000, 247.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.754,13.348 L14.8,17.302 L13.246,15.754 L12.4,16.6 L14.8,19 L19.6,14.2 L18.754,13.348 Z M6,10 L18,10 L18,12 L6,12 L6,10 Z M6,8 L18,8 L18,6 L6,6 L6,8 Z M6,16 L11,16 L11,14 L6,14 L6,16 Z",
    id: "EditList"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchChecklistDarkIcon);
export default __webpack_public_path__ + "static/media/SearchChecklistDarkIcon.58cd8ca5.svg";
export { ForwardRef as ReactComponent };